// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

// @constants
// const { TPP_KEYS_STATUS_ACTIVE } = require('constants/tpps');
const actionTypes = require('constants/actionTypes');

// const getConsents = () => new Promise((resolve) => {
//     setTimeout(() => {
//         resolve(/*consentsUser*/)
//     }, 2000)
// });

const requestTppKeyDataFailure = error => ({
    type: actionTypes.TPP_KEYS_REQUEST_DATA_FAILURE,
    payload: {
        error
    }
});

const requestTppKeyDataInProgress = () => ({
    type: actionTypes.TPP_KEYS_REQUEST_DATA_IN_PROGRESS
});

const requestTppKeyDataSuccess = tpps => ({
    type: actionTypes.TPP_KEYS_REQUEST_DATA_SUCCESS,
    payload: {
        tpps
    }
});

const getAllConsentsInProgress = () => ({
    type: actionTypes.GET_ALL_CONSENTS_IN_PROGRESS
});

const getAllConsentsSuccess = (consents) => ({
    type: actionTypes.GET_ALL_CONSENTS_SUCCESS,
    payload: consents
});

const getAllConsentsFailure = () => ({
    type: actionTypes.GET_ALL_CONSENTS_FAILURE,
});

const getAllConsents = (tppId) => dispatch => {
    dispatch(getAllConsentsInProgress());

    const params = {
        query: {
            tppId
        }
    }

    APIGet(dispatch, apiURLBuilder.getURL('tppConsents'), params)
    .then(consents => dispatch(getAllConsentsSuccess(consents)))
    .catch((error) => dispatch(getAllConsentsFailure(error)))
}

const getTppKeyConsentsInProgress = () => ({
    type: actionTypes.TPP_KEYS_GET_CONSENTS_IN_PROGRESS
});

const getTppKeyConsentsSuccess = (tpp) => ({
    type: actionTypes.TPP_KEYS_GET_CONSENTS_SUCCESS,
    payload: tpp
});

const getTppKeyConsentsFailure = () => ({
    type: actionTypes.TPP_KEYS_GET_CONSENTS_FAILURE,
});

const getTppKeyConsents = (tppId) => dispatch => {
    dispatch(getTppKeyConsentsInProgress());

    const params = {
        tppId
    }

    APIGet(dispatch, apiURLBuilder.getURL('tppUserDetail', params))
    .then(tpp => {
        dispatch(getTppKeyConsentsSuccess(tpp))
        dispatch(getAllConsents(tppId))
    })
    .catch((error) => dispatch(getTppKeyConsentsFailure(error)))
}

const updateTppKeysTab = () => ({
    type: actionTypes.TPP_KEYS_UPDATE_TAB
});


const requestTppKeysData = () => dispatch => {
    dispatch(requestTppKeyDataInProgress());

    return APIGet(dispatch, apiURLBuilder.getURL('tppUserList'))
        .then((response) => dispatch(requestTppKeyDataSuccess(response ? response.tpps : [])))
        .catch(error => {
            if (error) {
                dispatch(requestTppKeyDataFailure(error))
            } else {
                throw error;
            }
        })
}

const resetTppKey = () => ({
    type: actionTypes.TPP_KEYS_RESET_TPP_KEY,
});

const getMovementsInProgress = id => ({
    type: actionTypes.TPP_KEYS_GET_MOVEMENTS_IN_PROGRESS,
    payload: {
        id
    }
});

const getMovementsSuccess = (id, movements) => ({
    type: actionTypes.TPP_KEYS_GET_MOVEMENTS_SUCCESS,
    payload: {
        id,
        movements
    }
});

const getMovementsFailure = id => ({
    type: actionTypes.TPP_KEYS_GET_MOVEMENTS_FAILURE,
    payload: {
        id
    }
});

const getMovements = () => (
    new Promise((resolve) => {
        setTimeout(() => {
            resolve(/*initialMovements*/)
        }, 2000)
    })
);

const loadMovements = id => dispatch => {
    dispatch(getMovementsInProgress(id));
    getMovements()
    .then( movements => dispatch(getMovementsSuccess(id, movements)))
    .catch(() => dispatch(getMovementsFailure(id)));
}

const setExpandedTppKeyAccordion = (id, expanded = true) => ({
    type: actionTypes.TPP_KEYS_SET_EXPANDED_TPP_ACCORDION,
    payload: {
        id,
        expanded
    }
});

module.exports = {
    // getConsents,
    getTppKeyConsents,
    loadMovements,
    requestTppKeysData,
    resetTppKey,
    setExpandedTppKeyAccordion,
    updateTppKeysTab
}
